"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var DecoderHint_1 = require("./DecoderHint"),
    DecoderResponseError = function () {
  function e(e, s) {
    var o = this;
    this.hints = [], e.errorCode && (this.errorCode = e.errorCode), e.message && (this.message = e.message), e.debugInfo && (this.debugInfo = e.debugInfo), e.sessionToken && (this.sessionToken = e.sessionToken), e.hints && e.hints.forEach(function (e) {
      var r = new DecoderHint_1.default(s, e.code, e.message, e.debugInfo);
      o.hints.push(r);
    });
  }

  return e.prototype.description = function () {
    return "errorCode: " + this.errorCode + ", message: " + this.message;
  }, e;
}();

exports.DecoderResponseError = DecoderResponseError;